// import React from 'react';
// import './WhyChooseUs.css';
// import one from '../assets/mic.png';
// import two from '../assets/tick.png';
// import three from '../assets/shield.png';

// const WhyChooseUs = () => {
//   const reasons = [
//     {
//        title: 'Verified Listings',
//        desc:'All properties are verified by our experts',
//        img: two,
//     },
//     {
//          title: 'Expert Support',
//        desc:'customer service for your needs',
//        img:one,
//     },
//     {
//        title: 'Secure Transactions',
//        desc:'safe and secure payment methods',
//        img:three
//     },
//     {
//          title: 'Expert Support',
//        desc:'customer service for your needs',
//        img:one
//     }
//   ];

//   return (
//     <div className='good'>
//     <section className="why-us">
//       <h2>Why Choose Us</h2>
//       <div className="reason-list">
//         {reasons.map((item, idx) => (
//           <div className="reason-card" key={idx}>
//             <img src={item.img}/>
//             <h3>{item.title}</h3>
//             <p>{item.desc}</p>
//           </div>
//         ))}
//       </div>
//     </section>
    
//    <div className='hi'>
//   <label>Property Deals Talk.COM:</label>
//   <div className="content-wrapper">
//     <h1>Your Guide To Navigating The Real Estate Marketing</h1>
//     <div className="button-wrapper">
//       <button>Contact Us</button>  
//     </div>
//   </div>
//   <p>Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security</p>   
// </div>


    
//   </div>
//   );
// };

// export default WhyChooseUs;





// import React from 'react';
// import './WhyChooseUs.css';
// import micIcon from '../../assets/mic.png';
// import tickIcon from '../../assets/tick.png';
// import shieldIcon from '../../assets/shield.png';

// const WhyChooseUs = () => {
//   const reasons = [
//     {
//       title: 'Verified Listings',
//       desc: 'All properties are verified by our experts',
//       img: tickIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//     {
//       title: 'Secure Transactions',
//       desc: 'Safe and secure payment methods',
//       img: shieldIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     }
//   ];

//   return (
//     <div className="why-choose-wrapper">
//       <div className="over"></div>
//       <section className="why-us">
//         <h2>Why Choose Us</h2>
//         <div className="reason-list">
//           {reasons.map((item, idx) => (
//             <div className="reason-card" key={idx}>
//               <img src={item.img} alt="icon" />
//               <h3>{item.title}</h3>
//               <p>{item.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       <div className="hi">
//         <label>Property Deals Talk.COM:Your Guide To Navigating</label>
//         <div className="content-wrapper">
//           <h1> The Real Estate Marketing</h1>
//           <div className="button-wrapper">
//             <button>Contact Us</button>
//           </div>
//         </div>
//         <p>Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security</p>
//       </div>
//     </div>
//   );
// };

// export default WhyChooseUs;

// import React from 'react';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';
// import micIcon from '../../../assets/mic.png';
// import tickIcon from '../../../assets/tick.png';
// import shieldIcon from '../../../assets/shield.png';
// import officeBg from '../../../assets/office.png';

// const reasons = [
//   {
//     title: 'Verified Listings',
//     desc: 'All properties are verified by our experts',
//     img: tickIcon,
//   },
//   {
//     title: 'Expert Support',
//     desc: '24/7 customer service for your needs',
//     img: micIcon,
//   },
//   {
//     title: 'Secure Transactions',
//     desc: 'Safe and secure payment methods',
//     img: shieldIcon,
//   },
//   {
//     title: 'Expert Support',
//     desc: '24/7 customer service for your needs',
//     img: micIcon,
//   },
// ];

// const WhyChooseUs = () => {
//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         backgroundImage: `url(${officeBg})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center top',
//         backgroundSize: 'auto',
//         backgroundAttachment: 'fixed',
//         overflow: 'hidden',
//         fontFamily: 'Outfit, sans-serif',
//         width: '100%',
//       }}
//     >
//       {/* Dark overlay */}
//       <Box
//         sx={{
//           position: 'absolute',
//           zIndex: 1,
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//         }}
//       />

//       {/* Why Choose Us Section */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           padding: '50px 20px',
//           textAlign: 'center',
//         }}
//       >
//         <Typography
//           variant="h2"
//           sx={{
//             fontSize: '1.8rem',
//             fontWeight: 600,
//             mb: 4,
//             color: 'white',
//           }}
//         >
//           Why Choose Us
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '20px',
//             pb: '10px',
//           }}
//         >
//           {reasons.map((item, idx) => (
//             <Box
//               key={idx}
//               sx={{
//                 backgroundColor: 'white',
//                 padding: '10px',
//                 borderRadius: '10px',
//                 width: { xs: '100%', sm: '300px', md: '330px' },
//                 minHeight: '120px',
//                 textAlign: 'center',
//                 boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//                 transition: 'transform 0.3s',
//                 '&:hover': {
//                   transform: 'translateY(-5px)',
//                 },
//               }}
//             >
//               <Box
//                 component="img"
//                 src={item.img}
//                 alt="icon"
//                 sx={{ width: 40, height: 40, mb: 1.5 }}
//               />
//               <Typography sx={{ fontWeight: 600, m: 0 }}>{item.title}</Typography>
//               <Typography
//                 sx={{
//                   fontWeight: 400,
//                   fontSize: 14,
//                   color: 'grey',
//                   mt: '8px',
//                 }}
//               >
//                 {item.desc}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* Property Guide Section */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           padding: { xs: '30px 20px', md: '40px 20px' },
//           textAlign: { xs: 'center', md: 'left' },
//         }}
//       >
//         <Typography
//           component="label"
//           sx={{
//             fontSize: 24,
//             fontWeight: 500,
//             display: 'block',
//             mb: 2,
//             color: 'white',
//           }}
//         >
//           Property Deals Talk.COM:Your Guide To Navigating
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: { xs: 'center', md: 'space-between' },
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '20px',
//           }}
//         >
//           <Typography
//             variant="h1"
//             sx={{
//               fontSize: { xs: 20, md: 24 },
//               fontWeight: 500,
//               color: 'white',
//               m: 0,
//               flex: 1,
//               minWidth: 200,
//               textAlign: { xs: 'center', md: 'left' },
//             }}
//           >
//             The Real Estate Marketing
//           </Typography>

//           <Box
//             sx={{
//               width: { xs: '100%', md: 'auto' },
//               display: 'flex',
//               justifyContent: { xs: 'center', md: 'flex-end' },
//             }}
//           >
//             <Button
//               sx={{
//                 padding: '10px 20px',
//                 backgroundColor: '#f8a600',
//                 color: 'white',
//                 fontWeight: 500,
//                 fontSize: '0.95rem',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 textTransform: 'none',
//                 '&:hover': {
//                   backgroundColor: '#e89e00',
//                 },
//               }}
//             >
//               Contact Us
//             </Button>
//           </Box>
//         </Box>

//         <Typography
//           sx={{
//             mt: 3,
//             fontWeight: 400,
//             fontSize: 14,
//             color: 'white',
//             maxWidth: '700px',
//             textAlign: { xs: 'center', md: 'left' },
//             mx: { xs: 'auto', md: 0 },
//           }}
//         >
//           Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default WhyChooseUs;

// import React from 'react';
// import { useSelector } from 'react-redux';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';

// import micIcon from '../../../assets/mic.png';
// import tickIcon from '../../../assets/tick.png';
// import shieldIcon from '../../../assets/shield.png';
// import wideSelectionIcon from '../../../assets/wide-selection.png'; 
// import officeBg from '../../../assets/office.png';

// const WhyChooseUs = () => {
//   const user = useSelector(state => state.user.user); 
//   const isLoggedIn = !!user?.token;

  
//   const reasons = [
//     {
//       title: 'Verified Listings',
//       desc: 'All properties are verified by our experts',
//       img: tickIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//     {
//       title: 'Secure Transactions',
//       desc: 'Safe and secure payment methods',
//       img: shieldIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//   ];

  
//   if (isLoggedIn) {
//     reasons[3] = {
//       title: 'Wide Selection',
//       desc: 'Extensive range of properties',
//       img: wideSelectionIcon,
//     };
//   }

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         backgroundImage: `url(${officeBg})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center top',
//         backgroundSize: 'auto',
//         backgroundAttachment: 'fixed',
//         overflow: 'hidden',
//         fontFamily: 'Outfit, sans-serif',
//         width: '100%',
//       }}
//     >
     
//       <Box
//         sx={{
//           position: 'absolute',
//           zIndex: 1,
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//         }}
//       />

     
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           padding: '50px 20px',
//           textAlign: 'center',
//         }}
//       >
//         <Typography
//           variant="h2"
//           sx={{
//             fontSize: '1.8rem',
//             fontWeight: 600,
//             mb: 4,
//             color: 'white',
//           }}
//         >
//           Why Choose Us
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '20px',
//             pb: '10px',
//           }}
//         >
//           {reasons.map((item, idx) => (
//             <Box
//               key={idx}
//               sx={{
//                 backgroundColor: 'white',
//                 padding: '10px',
//                 borderRadius: '10px',
//                 width: { xs: '100%', sm: '300px', md: '330px' },
//                 minHeight: '120px',
//                 textAlign: 'center',
//                 boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//                 transition: 'transform 0.3s',
//                 '&:hover': {
//                   transform: 'translateY(-5px)',
//                 },
//               }}
//             >
//               <Box
//                 component="img"
//                 src={item.img}
//                 alt="icon"
//                 sx={{ width: 40, height: 40, mb: 1.5 }}
//               />
//               <Typography sx={{ fontWeight: 600, m: 0 }}>{item.title}</Typography>
//               <Typography
//                 sx={{
//                   fontWeight: 400,
//                   fontSize: 14,
//                   color: 'grey',
//                   mt: '8px',
//                 }}
//               >
//                 {item.desc}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

      
//     </Box>
//   );
// };

// export default WhyChooseUs;

// import React from 'react';
// import { useSelector } from 'react-redux';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';

// import micIcon from '../../../assets/mic.png';
// import tickIcon from '../../../assets/tick.png';
// import shieldIcon from '../../../assets/shield.png';
// import wideSelectionIcon from '../../../assets/logvector.png'; // ✅ your new icon
// import officeBg from '../../../assets/office.png';

// // Import your selector for clean code
// import { selectIsAuthenticated } from '../../../Commonlibs/userSlice'; // ✅ adjust path!

// const WhyChooseUs = () => {
//   const isLoggedIn = useSelector(selectIsAuthenticated); // ✅ robust way

//   // Base reasons
//   const reasons = [
//     {
//       title: 'Verified Listings',
//       desc: 'All properties are verified by our experts',
//       img: tickIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//     {
//       title: 'Secure Transactions',
//       desc: 'Safe and secure payment methods',
//       img: shieldIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//   ];

//   // ✅ Overwrite last reason if logged in
//   if (isLoggedIn) {
//     reasons[3] = {
//       title: 'Wide Selection',
//       desc: 'Extensive range of properties',
//       img: wideSelectionIcon,
//     };
//   }

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         backgroundImage: `url(${officeBg})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center top',
//         backgroundSize: 'auto',
//         backgroundAttachment: 'fixed',
//         overflow: 'hidden',
//         fontFamily: 'Outfit, sans-serif',
//         width: '100%',
//       }}
//     >
//       {/* Dark overlay */}
//       <Box
//         sx={{
//           position: 'absolute',
//           zIndex: 1,
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//         }}
//       />

//       {/* Why Choose Us Section */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           padding: '50px 20px',
//           textAlign: 'center',
//         }}
//       >
//         <Typography
//           variant="h2"
//           sx={{
//             fontSize: '1.8rem',
//             fontWeight: 600,
//             mb: 4,
//             color: 'white',
//           }}
//         >
//           Why Choose Us
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '20px',
//             pb: '10px',
//           }}
//         >
//           {reasons.map((item, idx) => (
//             <Box
//               key={idx}
//               sx={{
//                 backgroundColor: 'white',
//                 padding: '10px',
//                 borderRadius: '10px',
//                 width: { xs: '100%', sm: '300px', md: '330px' },
//                 minHeight: '120px',
//                 textAlign: 'center',
//                 boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//                 transition: 'transform 0.3s',
//                 '&:hover': {
//                   transform: 'translateY(-5px)',
//                 },
//               }}
//             >
//               <Box
//                 component="img"
//                 src={item.img}
//                 alt="icon"
//                 sx={{ width: 40, height: 40, mb: 1.5 }}
//               />
//               <Typography sx={{ fontWeight: 600, m: 0 }}>{item.title}</Typography>
//               <Typography
//                 sx={{
//                   fontWeight: 400,
//                   fontSize: 14,
//                   color: 'grey',
//                   mt: '8px',
//                 }}
//               >
//                 {item.desc}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* ✅ Property Guide Section (unchanged) */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           padding: { xs: '30px 20px', md: '40px 20px' },
//           textAlign: { xs: 'center', md: 'left' },
//         }}
//       >
//         <Typography
//           component="label"
//           sx={{
//             fontSize: 24,
//             fontWeight: 500,
//             display: 'block',
//             mb: 2,
//             color: 'white',
//           }}
//         >
//           Property Deals Talk.COM: Your Guide To Navigating
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: { xs: 'center', md: 'space-between' },
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '20px',
//           }}
//         >
//           <Typography
//             variant="h1"
//             sx={{
//               fontSize: { xs: 20, md: 24 },
//               fontWeight: 500,
//               color: 'white',
//               m: 0,
//               flex: 1,
//               minWidth: 200,
//               textAlign: { xs: 'center', md: 'left' },
//             }}
//           >
//             The Real Estate Marketing
//           </Typography>

//           <Box
//             sx={{
//               width: { xs: '100%', md: 'auto' },
//               display: 'flex',
//               justifyContent: { xs: 'center', md: 'flex-end' },
//             }}
//           >
//             <Button
//               sx={{
//                 padding: '10px 20px',
//                 backgroundColor: '#f8a600',
//                 color: 'white',
//                 fontWeight: 500,
//                 fontSize: '0.95rem',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 textTransform: 'none',
//                 '&:hover': {
//                   backgroundColor: '#e89e00',
//                 },
//               }}
//             >
//               Contact Us
//             </Button>
//           </Box>
//         </Box>

//         <Typography
//           sx={{
//             mt: 3,
//             fontWeight: 400,
//             fontSize: 14,
//             color: 'white',
//             maxWidth: '700px',
//             textAlign: { xs: 'center', md: 'left' },
//             mx: { xs: 'auto', md: 0 },
//           }}
//         >
//           Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default WhyChooseUs;


// import React from 'react';
// import { useSelector } from 'react-redux';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';

// import micIcon from '../../../assets/mic.png';
// import tickIcon from '../../../assets/tick.png';
// import shieldIcon from '../../../assets/shield.png';
// import wideSelectionIcon from '../../../assets/logvector.png';
// import officeBg from '../../../assets/office.png';

// import { selectIsAuthenticated } from '../../../Commonlibs/userSlice';

// const WhyChooseUs = () => {
//   const isLoggedIn = useSelector(selectIsAuthenticated);

//   const reasons = [
//     {
//       title: 'Verified Listings',
//       desc: 'All properties are verified by our experts',
//       img: tickIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//     {
//       title: 'Secure Transactions',
//       desc: 'Safe and secure payment methods',
//       img: shieldIcon,
//     },
//     {
//       title: 'Expert Support',
//       desc: '24/7 customer service for your needs',
//       img: micIcon,
//     },
//   ];

//   if (isLoggedIn) {
//     reasons[3] = {
//       title: 'Wide Selection',
//       desc: 'Extensive range of properties',
//       img: wideSelectionIcon,
//     };
//   }

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         backgroundImage: `url(${officeBg})`,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center top',
//         backgroundSize: 'auto',
//         backgroundAttachment: 'fixed',
//         overflow: 'hidden',
//         fontFamily: 'Outfit, sans-serif',
//         width: '100%',
//       }}
//     >
//       {/* Overlay */}
//       <Box
//         sx={{
//           position: 'absolute',
//           zIndex: 1,
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//         }}
//       />

//       {/* Main Section */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           padding: '50px 20px',
//           textAlign: 'center',
//         }}
//       >
//         <Typography
//           variant="h2"
//           sx={{
//             fontSize: '1.8rem',
//             fontWeight: 500,
//             mb: 4,
//             color: 'white',
//           }}
//         >
//           Why Choose Us
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '20px',
//             pb: '10px',
//           }}
//         >
//           {reasons.map((item, idx) => (
//             <Box
//               key={idx}
//               sx={{
//                 backgroundColor: 'white',
//                 padding: '10px',
//                 borderRadius: '10px',
//                 width: { xs: '100%', sm: '300px', md: '330px' },
//                 minHeight: '120px',
//                 textAlign: 'center',
//                 boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//                 transition: 'transform 0.3s',
//                 '&:hover': {
//                   transform: 'translateY(-5px)',
//                 },
//               }}
//             >
//               <Box
//                 component="img"
//                 src={item.img}
//                 alt="icon"
//                 sx={{ width: 40, height: 40, mb: 1.5 }}
//               />
//               <Typography sx={{ fontWeight: 500, m: 0 }}>{item.title}</Typography>
//               <Typography
//                 sx={{
//                   fontWeight: 400,
//                   fontSize: 14,
//                   color: '#626262',
//                   mt: '8px',
//                 }}
//               >
//                 {item.desc}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* Guide Section */}
//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           padding: { xs: '30px 20px', md: '40px 20px' },
//           textAlign: { xs: 'center', md: 'left' },
//         }}
//       >
//         <Typography
//           component="label"
//           sx={{
//             fontSize: 34,
//             fontWeight: 500,
//             display: 'block',
//             mb: 2,
//             color: 'white',
//           }}
//         >
//           Property Deals Talk.COM: Your Guide To Navigating
//         </Typography>

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: { xs: 'center', md: 'space-between' },
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             gap: '20px',
//           }}
//         >
//           <Typography
//             variant="h1"
//             sx={{
//               fontSize: { xs: 20, md: 24 },
//               fontWeight: 500,
//               color: 'white',
//               m: 0,
//               flex: 1,
//               minWidth: 200,
//               textAlign: { xs: 'center', md: 'left' },
//             }}
//           >
//             The Real Estate Marketing
//           </Typography>

//           <Box
//             sx={{
//               width: { xs: '100%', md: 'auto' },
//               display: 'flex',
//               justifyContent: { xs: 'center', md: 'flex-end' },
//               mr: { xs: 0, md: '80px' },
//             }}
//           >
//             <Button
//               sx={{
//                 padding: '10px 20px',
//                 backgroundColor: '#f8a600',
//                 color: 'white',
//                 fontWeight: 500,
//                 fontSize: '0.95rem',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 textTransform: 'none',
//                 '&:hover': {
//                   backgroundColor: '#e89e00',
//                 },
//               }}
//             >
//               Contact Us
//             </Button>
//           </Box>
//         </Box>

//         <Typography
//           sx={{
//             mt: 3,
//             fontWeight: 400,
//             fontSize: 14,
//             color: 'white',
//             maxWidth: '700px',
//             textAlign: { xs: 'center', md: 'left' },
//             mx: { xs: 'auto', md: 0 },
//           }}
//         >
//           Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default WhyChooseUs;


import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import micIcon from '../../../assets/mic.png';
import tickIcon from '../../../assets/tick.png';
import shieldIcon from '../../../assets/shield.png';
import wideSelectionIcon from '../../../assets/logvector.png';
import officeBg from '../../../assets/office.png';
import { selectIsAuthenticated } from '../../../Commonlibs/userSlice';
 
const WhyChooseUs = () => {
  const isLoggedIn = useSelector(selectIsAuthenticated);
 
  const reasons = [
    {
      title: 'Verified Listings',
      desc: 'All properties are verified by our experts',
      img: tickIcon,
    },
    {
      title: 'Expert Support',
      desc: '24/7 customer service for your needs',
      img: micIcon,
    },
    {
      title: 'Secure Transactions',
      desc: 'Safe and secure payment methods',
      img: shieldIcon,
    },
    {
      title: 'Expert Support',
      desc: '24/7 customer service for your needs',
      img: micIcon,
    },
  ];
 
  if (isLoggedIn) {
    reasons[3] = {
      title: 'Wide Selection',
      desc: 'Extensive range of properties',
      img: wideSelectionIcon,
    };
  }
 
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundImage: `url(${officeBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        overflow: 'hidden',
        fontFamily: 'Outfit, sans-serif',
        width: '100%',
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)',
        }}
      />
      {/* Main Section */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          padding: { xs: '20px 20px', md: '30px 20px' },
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '1.5rem', md: '1.8rem' },
            fontWeight: 500,
            mb: 2,
              mt: 3,
            color: 'white',
          }}
        >
          Why Choose Us
        </Typography>
       
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
            pb: '10px',
            overflowX: { sm: 'auto' },
            width: '100%',
              mt: 3,
              mb:3
          }}
        >
          {reasons.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                backgroundColor: 'white',
                padding: '15px',
                borderRadius: '10px',
                width: { xs: '100%', sm: '260px', md: '280px' },
                minWidth: { sm: '260px', md: '280px' },
                minHeight: '150px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                transition: 'transform 0.3s',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                component="img"
                src={item.img}
                alt="icon"
                sx={{ width: 35, height: 35, mb: 1 }}
              />
              <Typography sx={{ fontWeight: 500, m: 0 }}>{item.title}</Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: 14,
                  color: '#626262',
                  mt: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%'
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      {/* Guide Section */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          padding: { xs: '20px 20px', md: '30px 20px' },
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        <Typography
          component="label"
          sx={{
            fontSize: { xs: '1.5rem', md: '1.5rem' },
            fontWeight: 400,
            display: 'block',
             mt: 3,
            color: 'white',
            lineHeight: 1,
          }}
        >
          Property Deals Talk.COM: Your Guide To Navigating
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'center', md: 'space-between' },
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '15px',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '1.25rem',  md: '1.5rem' },
              fontWeight: 400,
              color: 'white',
              m: 0,
              flex: 1,
              minWidth: 200,
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            The Real Estate Marketing
          </Typography>
          <Box
            sx={{
              width: { xs: '100%', md: 'auto' },
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              mr: { xs: 0, md: '80px' },
            }}
          >
            <Button
              sx={{
                padding: '8px 18px',
                backgroundColor: '#f8a600',
                color: 'white',
                fontWeight: 500,
                fontSize: '0.95rem',
                borderRadius: '6px',
                cursor: 'pointer',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#e89e00',
                },
              }}
            >
              Contact Us
            </Button>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: 3,
            mb:3,
            fontWeight: 400,
            fontSize: 14,
            color: 'white',
            maxWidth: '700px',
            textAlign: { xs: 'center', md: 'left' },
            mx: { xs: 'auto', md: 0 },
          }}
        >
          Investing In Real Estate is a Smart Use That Can Lead to Long term Financial Security
        </Typography>
      </Box>
    </Box>
  );
};
 
export default WhyChooseUs;
 
